export interface NotificationSettingResponse {
  id?: number;
  notifiableType: string;
  notifiableId: string;
  type: string;
  settings: { [key: string]: boolean };
  createdAt?: number;
  updatedAt?: number;
}

export type NotificationSettingId = number;

export enum NotificationSettingType {
  APP = 'app',
  EMAIL = 'email',
  SMS = 'sms',
}

export enum NotifiableSettingType {
  USER = 'App\\Models\\User',
  COMPANY = 'App\\Models\\Company',
  TEAM = 'App\\Models\\Team',
}
